import { BLOGS_API } from 'modules/blogs/api/blog-api'
import { BlogCategoriesApiInterface } from 'modules/blogs/types/blog-categories-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

interface UseBlogCategoriesInterface extends SwrPaginationInterface {
  id: string
  needFetch?: boolean
}

export function useBlogCategories({ id, pagination, limit }: UseBlogCategoriesInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, BlogCategoriesApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: blogCategories, mutate: blogCategoriesMutate } = useSWR(() => {
    if (user && pagination.startFromId === undefined && limit) {
      return `${BLOGS_API}/${id}/categories/list?pagination[limit]=${limit}`
    } else if (user && pagination.startFromId && limit) {
      return `${BLOGS_API}/${id}/categories/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`
    }
    return null
  }, fetcher)

  const { data: blogCategoriesCounter } = useSWR<CountInterface>(() => {
    if (user) {
      return `${BLOGS_API}/${id}/categories/count?pagination[limit]`
    }
    return null
  }, baseFetcher)

  return {
    blogCategories,
    blogCategoriesMutate,
    blogCategoriesCounter,
  }
}
